<template>
    <div>
    <h1>Agregar Créditos de Viaje</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Concesionario">
                <v-select :options="Object.values(getConcesionarios)" :reduce="franch => franch.id" v-model="$v.getPaymentsById.concesionario.id.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getPaymentsById.concesionario.id.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Viajes">
                <a-input placeholder="Número de Viajes" v-model="getPaymentsById.tripsNumber" @change="calcularMonto"/>
                <small class="text-danger" v-if="!$v.getPaymentsById.tripsNumber.required">Campo requerido</small>
                <small class="text-danger" v-if="!$v.getPaymentsById.tripsNumber.numeric">Ingresa un número de viajes válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Monto de Pago">
                <a-input placeholder="Monto de Pago" v-model="$v.getPaymentsById.amount.$model" readOnly/>
                <small class="text-danger" v-if="!$v.getPaymentsById.amount.required">Campo requerido</small>
                <small class="text-danger" v-if="!$v.getPaymentsById.amount.numeric">Dato no válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Pagado Por">
                <a-input placeholder="Pagado Por" v-model="$v.getPaymentsById.paidBy.$model"/>
                <small class="text-danger" v-if="!$v.getPaymentsById.paidBy.required">Campo requerido</small>
              </a-form-item>
            </div>
          </div>
          <div class="row">
              <div class="col-6">
                  <label>Agregar Comprobante de Pago</label>
                   <b-form-file
                   type="file"
                accept="application/pdf,image/x-png,image/gif,image/jpeg"
                v-model="$v.fileUploaded.$model"
                :state="Boolean(fileUploaded)"
                :placeholder="this.elNombre"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                ></b-form-file>
                <small class="text-danger" v-if="!$v.fileUploaded.required">Campo requerido</small>
              </div>
          </div>
          <br>
          <br>
          <br>
          <div class="row">
              <div class="col-12">
              <a-form-item>
                <button
                :disabled="this.disabledButton"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
import { uploadFileS3 } from '../../../s3/s3Up'
import headers from '@/config/headers.js'
// import { encrypt } from '@/config/headers'
export default {
  data: function () {
    return {
      elNombre: 'Elige un archivo...',
      disabledButton: false,
      form: this.$form.createForm(this),
      fileExtension: null,
      filePathLoaded: null,
      id: this.$route.params.id,
      error: null,
      getPaymentsById: {
        concesionario: {
          id: null,
        },
        fileUrl: null,
        tripsNumber: null,
        amount: null,
        paidBy: null,
      },
      getConcesionarios: [{
        id: 0,
        name: '',
      }],
      objectFile: [],
      selectedFile: null,
      selectedFileName: null,
      uploaded: false,
      fileUploaded: null,
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
    }
  },
  apollo: {
    getConcesionarios: {
      query: gql`
        query getConcesionarios{
      getConcesionarios{
        id
        label: name  
      }
     }`,
      context: headers(),
      result ({ data, loading, networkStatus }) {
      },
    },
    getPaymentsById: {
      query: gql`
        query getPaymentsById($id: Int!) {
          getPaymentsById(id: $id) {
            id
            concesionario{
              id
              name
              rfc
            }
            fileUrl
            tripsNumber
            amount
            paidBy
          }
        }
      `,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      variables() {
        return {
          id: this.id ? parseInt(this.id) : 1,
        }
      },
      skip() {
        return this.skipQuery
      },
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.$apollo.queries.getPaymentsById.skip = false
      if (this.getPaymentsById.fileUrl != null) {
        this.elNombre = this.getPaymentsById.fileUrl
      }
    }
  },
  methods: {
    calcularMonto() {
      this.getPaymentsById.amount = this.getPaymentsById.tripsNumber * 7
    },
    onFileSelected(event) {
      this.fileUploaded = event.target.files[0]
      this.getPaymentsById.fileUrl = this.fileUploaded
      this.fileExtension = this.fileUploaded.name.split('.').pop()
    },

    async handleSubmit() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      if (this.id != null) {
        if (this.fileUploaded != null) {
          await this.fileUploadToS3()
        }
      } else {
        if (this.fileUploaded != null) {
          this.objectFile.fileExtension = this.fileExtension
          this.objectFile.fileUploaded = this.fileUploaded
          const data = await uploadFileS3(this.objectFile)
          this.filePathLoaded = data.Location
          /*
            .then(data => {
              this.filePathLoaded = data.Location
            })
            .catch(err => {
              console.log(err)
            })
            */
        }
        await this.$apollo.mutate({
          mutation: gql`mutation createConcesionarioPayment($concesionarioId: Int, $fileUrl: String, $tripsNumber: Int, $amount: Float, $paidBy: String) {
         createConcesionarioPayment(payment: {
          concesionarioId: $concesionarioId
          fileUrl: $fileUrl
          tripsNumber: $tripsNumber
          amount: $amount
          paidBy: $paidBy
        }){
          id
          concesionario{
            id
            name
            rfc
          }
          fileUrl
          tripsNumber
          amount
          paidBy
        }
        }`,
          context: headers(),
          variables: {
            concesionarioId: parseInt(this.getPaymentsById.concesionario.id),
            fileUrl: this.filePathLoaded,
            tripsNumber: parseInt(this.getPaymentsById.tripsNumber),
            amount: parseFloat(this.getPaymentsById.amount),
            paidBy: this.getPaymentsById.paidBy,
          },
        })
          .then(res => {
            this.$router.push('/concesionarios/getFranchisesPayments')
          })
          .catch(error => {
            this.disabledButton = false
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
            console.log(error)
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
  validations: {
    getPaymentsById: {
      concesionario: {
        id: { required },
      },
      tripsNumber: { required, numeric },
      amount: { required, numeric },
      paidBy: { required },
    },
    fileUploaded: { required },
  },
}
</script>

<style>
img {
    max-width: 50%;
    height: auto;
}
</style>
